import Repository from "./Repository";
import DocumentGroup from "../types/DocumentGroup";
import DocumentGroupsResponse from "./response/DocumentGroupsResponse";
import DocumentGroupResponse from "./response/DocumentGroupResponse";
import Axios from "axios";

const resource = "/documentGroup";

export default {
  get(groupId: string) {
    return Repository.get<DocumentGroupResponse>(`${resource}/${groupId}`);
  },
  getByCompany(companyId: string) {
    return Repository.get<DocumentGroupsResponse>(
      `${resource}/company/${companyId}`
    );
  },
  getByEmployee(employeeId: string) {
    return Repository.get<DocumentGroupsResponse>(
      `${resource}/employee/${employeeId}`
    );
  },
  save(documentGroup: DocumentGroup) {
    if (documentGroup.groupId) {
      return Repository.patch<DocumentGroupResponse>(
        `${resource}/${documentGroup.groupId}`,
        documentGroup
      );
    } else {
      return Repository.post<DocumentGroupResponse>(
        `${resource}`,
        documentGroup
      );
    }
  },
  saveAll(documentGroups: DocumentGroup[]) {
    let reqs: any = [];
    for (let documentGroup of documentGroups) {
      reqs.push(this.save(documentGroup));
    }
    return Axios.all(reqs);
  },
  addDocument(companyId: string, groupId: string, documentId: string) {
    return Repository.post(`${resource}/addDocument`, {
      companyId,
      groupId,
      documentId
    });
  },
  deleteDocument(groupId: string, documentId: string) {
    return Repository.delete(
      `${resource}/${groupId}/removeDocument/${documentId}`
    );
  },
  deleteDocuments(groupId: string, documentIds: string[]) {
    let a = [];
    for (let id of documentIds) {
      a.push(this.deleteDocument(groupId, id));
    }
    return Axios.all(a);
  },
  addToEmployee(companyId: string, groupId: string, employeeId: string) {
    return Repository.post(`${resource}/${groupId}/employee`, {
      companyId,
      groupId,
      employeeId
    });
  },
  addToGroup(
    companyId: string,
    documentGroupId: string,
    employeeGroupId: string
  ) {
    return Repository.post(`${resource}/${documentGroupId}/employeeGroup`, {
      companyId,
      documentGroupId,
      employeeGroupId
    });
  }
};
